import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { addPages, removePage } from '../../redux/reducers/navigationReducer/NavigationSlice';
import PageHeader from '../../components/common/pageHeader/PageHeader';
import { NavigationKey } from '../../components/appNavigationBar/AppNavigation.types';
import { TagsSection } from '../../components/tags';

const TagsPage: React.FC = () => {
    const dispatch = useAppDispatch();
    const selector = useAppSelector((state) => state);
    const { authReducer } = selector;

    useEffect(() => {
        dispatch(
            addPages([
                {
                    key: NavigationKey.DASHBOARD,
                    value: `${authReducer.user?.firstName}’s Dashboard`,
                },
                {
                    key: '/tags',
                    value: 'Tags',
                },
            ]),
        );
        return () => {
            dispatch(removePage());
        };
    }, []);

    return (
        <>
            <PageHeader title="Tags" />
            <TagsSection />
        </>
    );
};

export default TagsPage;
